var map = {
	"./bg-BG.json": 506,
	"./ca-ES.json": 507,
	"./cs-CZ.json": 508,
	"./de-DE.json": 509,
	"./el-GR.json": 510,
	"./en-US.json": 347,
	"./es-ES.json": 511,
	"./et-EE.json": 512,
	"./fi-FI.json": 513,
	"./fr-FR.json": 514,
	"./he-IL.json": 515,
	"./it-IT.json": 516,
	"./ja-JP.json": 517,
	"./ko-KR.json": 518,
	"./nb-NO.json": 519,
	"./nn-NO.json": 520,
	"./pl-PL.json": 521,
	"./pt-BR.json": 522,
	"./ru-RU.json": 523,
	"./sv-SE.json": 524,
	"./tr-TR.json": 525,
	"./zh-CN.json": 526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 505;